var _path, _path2, _circle, _circle2, _path3, _path4;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMappingError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1.5rem",
    height: "1.5rem",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z",
    fill: "white",
    stroke: "#C25454",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z",
    fill: "#C25454",
    fillOpacity: 0.3,
    stroke: "#C25454",
    strokeWidth: 1.5
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 17,
    r: 2,
    fill: "#C25454"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 17,
    r: 2,
    fill: "#C25454"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.99968 12.0001C6.99908 3.00078 17.5 3 15.4993 13.5005",
    stroke: "#C25454",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.33503 11.8917L8.4052 13.2536L9.04955 11.6459L7.33503 11.8917Z",
    fill: "#C25454",
    stroke: "#C25454"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMappingError);
export default __webpack_public_path__ + "static/media/mappingError.e3528917726ca0378efb1e41ae11eddc.svg";
export { ForwardRef as ReactComponent };